var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6M8 2.837A5.17 5.17 0 0 0 2.837 8 5.17 5.17 0 0 0 8 13.163 5.17 5.17 0 0 0 13.163 8 5.17 5.17 0 0 0 8 2.837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.116 10.3a.4.4 0 0 1-.218-.064L8.12 9.167a6 6 0 0 1-.422-.282.89.89 0 0 1-.347-.723V5.433c0-.236.195-.433.43-.433.236 0 .43.197.43.433V8.1c0 .208.173.219.351.323l1.78 1.069a.435.435 0 0 1-.225.809"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a8fa0c31015612c4e0d9ae5268c92baa.svg";
export { ForwardRef as ReactComponent };